import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // eslint-disable-next-line consistent-return
  async reportTeachingAssignmentTnh(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/tnhReports/reportTeachingAssignmentTnh',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },

  async getCourses(params) {
    try {
      const response = await axios.get('uni/courses', { params })
      const { data } = response
      return data.data?.records || []
    } catch (e) {
      handleCatch(e)
    }
    return []
  },

  async getYears() {
    try {
      const response = await axios.get('categories/factYears/all')
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
    return []
  },

  async getSemesters() {
    try {
      const response = await axios.get('uni/semesters/getAll')
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
    return []
  },

  async getMajorsByOrganizationId() {
    try {
      const response = await axios.get('uni/majors/getByOrganizationId')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
}
